/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AccountPairOverride {
  id?: number;
  accountId?: number;
  pairId?: number;
  bidCommissionRate?: number;
  askCommissionRate?: number;
  qtyLevelsTier?: AccountPairOverride.QtyLevelsTierEnum;
  active?: boolean;
}
export namespace AccountPairOverride {
  export const QtyLevelsTierEnum = {
    Small: 'SMALL',
    Regular: 'REGULAR',
    Big: 'BIG',
  } as const;
  export type QtyLevelsTierEnum = (typeof QtyLevelsTierEnum)[keyof typeof QtyLevelsTierEnum];
}
